import { useApi } from './api';

export const usePlayer = (fogisId) => useApi(`player?id=${fogisId}`);
